import Vue from 'vue'
import Component, { createDecorator, mixins as Mixins } from 'vue-class-component'
import { Prop, Emit, Inject, Model, Provide, Watch } from 'vue-property-decorator'
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class'

class BaseComponent extends Vue {

}

export {
  Component,
  BaseComponent,
  Vue,
  Mixins,
  Prop,
  Emit,
  Inject,
  Model,
  Provide,
  Watch,
  createDecorator,
  State,
  Getter,
  Action,
  Mutation,
  namespace
}
